import * as React from 'react';
import * as classnames from 'classnames/bind';

const styles = require('./HighlightedText.less');
const cx = classnames.bind(styles);

export interface HighlightedTextProps
{
    text:string;
    partToHighlight:string;
    className?:string;
    highlightedClassName?:string;
}

export class HighlightedText extends React.Component<HighlightedTextProps,any>
{
    render()
    {
        let {text, partToHighlight, className, highlightedClassName} = this.props;

        if( partToHighlight )
        {
            const idx = text.toLowerCase().indexOf(partToHighlight.trim().toLowerCase());
            if( idx > -1 )
            {
                const highlightLen = partToHighlight.length;
                const before = text.substring(0, idx);
                const matched = text.substring(idx, idx + highlightLen);
                const after = text.substring(idx + highlightLen, text.length);

                return (
                    <span className={cx('text', className)}>
                        {before}
                        <span className={cx('highlighted', highlightedClassName)}>
                            {matched}
                        </span>
                        {after}
                    </span>
                );
            }
        }

        return <span className={cx('text', className)}>
            {text}
        </span>;
    }
}